import $ from 'jquery';
import slick from 'slick-carousel';

let banner_percentage = 1;

export function seeInit() {
	$(window).resize(function() {	
		sizeBanners();
	});
	$(window).trigger('resize');
	
	var carousel = $('.carousel').slick({
		dots: true,
		autoplay: true,
		autoplaySpeed: 6000,
		accessibility: false,
		arrows: false,
		infinite: true,
		fade: true,
		pauseOnHover: false,
		speed: 1000,
		swipe: true
	});
	
	$('.promote').parent().hide();
	
	$('.more-button, .poster img').click(function() {
		var container = $(this).closest('.show');
		if (container.find('.poster').hasClass('col-md-4')) {
			container.find('button.more-button').text('Less Detail');
			container.find('.poster').removeClass('col-md-4 col-sm-5').addClass('col-lg-8 col-sm-9');
			container.find('.info').removeClass('col-md-19 col-sm-18').addClass('col-lg-15 col-sm-14');
			container.find('.desktop-details').removeClass('fade');
			container.find('.mobile-details').removeClass('fade');
			container.find('.promote').parent().show();
			setTimeout(function() {
				container.find('.promote').removeClass('fade');
			}, 1);
		} else {
			container.find('button.more-button').text('More Detail');
			container.find('.poster').removeClass('col-lg-8 col-sm-9').addClass('col-md-4 col-sm-5');
			container.find('.info').removeClass('col-lg-15 col-sm-14').addClass('col-md-19 col-sm-18');
			container.find('.desktop-details').addClass('fade');
			container.find('.mobile-details').addClass('fade');
			container.find('.promote').addClass('fade');
			setTimeout(function() {
				container.find('.promote').parent().hide();
			}, 500);
		}
	});
  
  $('#constant_contact').submit(function(e) {
    e.preventDefault();
    $('#cc_error').hide();
    $(this).find('button').text('Signing up');
    
    $.post($(this).attr('action'), $(this).serialize(), function(response) {
      if (response.success == true) {
        $('#constant_contact').slideUp();
        $('#cc_success').slideDown();
      } else {
        $('#constant_contact').find('button').text('Sign up');
        $('#cc_error').slideDown();
      }
    }).fail(function() {
      $('#constant_contact').find('button').text('Sign up');
      $('#cc_error').slideDown();
    });
    
    return false;
  });
}

function sizeBanners() {
	$('#banners').height($(window).height() * banner_percentage);
}